/* Design Components */
export {default as MonthPicker} from 'components/design/MonthPicker';
export {default as AlertDialog} from 'components/design/AlertDialog';
export {default as AlertDialogOneButton} from 'components/design/AlertDialogOneButton';
export {default as AlertDialogWithComments} from 'components/design/AlertDialogWithComments';
export {default as CancelButton} from 'components/design/CancelButton';
export {default as CancelButtonFlat} from 'components/design/CancelButtonFlat';
export {default as CountdownTimer} from 'components/design/CountdownTimer';
export {default as IconWithTooltip} from 'components/design/IconWithTooltip';
export {default as LoadingDialog} from 'components/design/LoadingDialog';
export {default as ModalWithChildren} from 'components/design/ModalWithChildren';
export {default as PrimaryButton} from 'components/design/PrimaryButton';
export {default as PrimaryButtonFlat} from 'components/design/PrimaryButtonFlat';
export {default as SecondaryButton} from 'components/design/SecondaryButton';
export {default as SecondaryButtonFlat} from 'components/design/SecondaryButtonFlat';
export {default as SignDialog} from 'components/design/SignDialog';
export {default as Stepper} from 'components/design/Stepper';
export {default as Waiting} from 'components/design/Waiting';
export {default as ImageLogin} from 'login-img.png';
export {default as Logo} from 'logo.png'

/* Color Palette */
export const PrimaryColor1 = "#1b2543";
export const PrimaryColor1Light = "#444e6b";
export const PrimaryColor2 = "#9e9e9e";
export const SuccessColor = "#11ab99";
export const SuccessColorLight = "#89d6c7";
export const FailureColor = "#ba0f0f";
export const FailureColorLight = "#eab6b8";
export const HightlightSoftColor = "#8c92a1";
export const ShadowColor = "#5c5f66";
export const GreyColor1 = "#f0f0ef";
export const GreyColor2 = "#fbfbfb";
export const NeutralColor = "#ff952b";

/* Typestyle */
export {style as style} from "typestyle";



// WEBPACK FOOTER //
// ./src/imports/DesignImports.js